import React, { useState, useEffect } from 'react';
import { Header, Footer } from './Container';
import Spinner from 'react-bootstrap/Spinner';
import {
	Container,
	Row,
	Col,
	Card,
	Form,
	ListGroup,
	Modal,
	Button,
	// Stack,
} from 'react-bootstrap';
import archiveLogo from '../assets/images/archive.svg';
import deleteLogo from '../assets/images/delete.svg';
import clockLogo from '../assets/images/clock-regular.svg';
import '../assets/css/Cogen.css';
import { ReqGet, ReqPost } from '../config/Requests';
import moment from 'moment';
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { Link } from 'react-router-dom';
import ReactPaginate from 'react-paginate';
import { MdOutlineCancel } from 'react-icons/md';
import { Stack } from '@mui/material';

function Notifications() {
	const styles = {
		title: {
			cursor: 'pointer',
		},
	};
	const [search, setSearch] = useState('');
	const [filterList, setFilterList] = useState([]);
	const [notificationList, setNotificationList] = useState([]);
	const [allUnread, setAllUnread] = useState(false);
	const [checkedItem, setCheckedItems] = useState([]);
	const [hide, setHide] = useState(true);
	const [totalPages, setTotalPages] = useState(0);
	const [currentPage, setCurrentPage] = useState(1);
	const [offset, setOffset] = useState(0);
	const [emptymessage, setEmptyMessage] = useState('');
	const [delectarchieveicons, setDelectArchieveIcons] = useState(true);

	const [request, setRequest] = useState({
		isInitiated: false,
		isSuccess: false,
		isFailed: false,
	});

	const notificationData = () => {
		setRequest({ isInitiated: true });
		if (id && id !== '0') {
			// TODO:: replace with singe job notification api
			ReqGet(`/notificationsbyid?job_id=${id}`)
				.then(res => {
					setRequest({ isInitiated: false, isSuccess: true });
					if (!res.data) return;
					setTotalPages(1);
					setNotificationList(res.data);
					setFilterList(res.data);

					if (checkedItem && checkedItem.length > 0) {
						const list = res.data.data.map(item => item.id);
						console.log(list);
						setCheckedItems(list);
					} else {
						setCheckedItems([]);
					}
				})
				.catch(err => {
					console.log(err.response);
					setRequest({ isSuccess: false, isFailed: true });
				});
		} else {
			if (allUnread == true) {
				ReqGet(`notification/unread?page=${currentPage}`)
					.then(res => {
						setTotalPages(res.data.total / 10);
						setNotificationList(res.data.data);
						setFilterList(res.data.data);
						setRequest({ isInitiated: false, isSuccess: true });
						if (checkedItem && checkedItem.length > 0) {
							const list = res.data.data.map(item => item.id);
							console.log(list);
							setCheckedItems(list);
						} else {
							setCheckedItems([]);
						}
					})
					.catch(err => {
						console.log(err.response);
						setRequest({ isSuccess: false, isFailed: true });
					});
			} else {
				ReqGet(`notifications?page=${currentPage}`)
					.then(res => {
						setTotalPages(res.data.total / 10);
						setNotificationList(res.data.data);
						setFilterList(res.data.data);
						setRequest({ isInitiated: false, isSuccess: true });
						if (checkedItem && checkedItem.length > 0) {
							const list = res.data.data.map(item => item.id);
							console.log(list);
							setCheckedItems(list);
						} else {
							setCheckedItems([]);
						}
					})
					.catch(err => {
						console.log(err.response);
						setRequest({ isSuccess: false, isFailed: true });
					});
			}
		}
	};
	useEffect(() => {
		notificationData();
	}, [currentPage, offset]);
	const handlePageClick = e => {
		const selectedPage = ++e.selected;
		const offset = selectedPage * 10;
		setCurrentPage(selectedPage);
		setOffset(offset);
	};
	const searchChangeHandler = event => {
		setSearch(event.target.value);
	};
	const searchRequestHandler = () => {
		setRequest({ isInitiated: true });
		ReqGet(`notifications?query=${search}`)
			.then(res => {
				if (res?.data?.data.length < 1) {
					setEmptyMessage('No notification found');
				} else {
					setEmptyMessage('');
				}

				console.log(totalPages + 'total pages');
				setTotalPages(res.data.total / 10);
				setNotificationList(res.data.data);
				setFilterList(res.data.data);
				setRequest({ isInitiated: false, isSuccess: true });
				if (checkedItem && checkedItem.length > 0) {
					const list = res.data.data.map(item => item.id);
					console.log(list);
					setCheckedItems(list);
				} else {
					setCheckedItems([]);
				}
			})
			.catch(err => {
				console.log(err.response);
				setRequest({ isSuccess: false, isFailed: true });
			});
	};

	let jobs = notificationList.map((item, i) => {
		return item.data.job;
	});

	const result = [];
	const map = new Map();
	for (const item of jobs) {
		if (!map.has(item.id)) {
			map.set(item.id, true);
			result.push({
				id: item.id,
				title: item.title,
				start_date: item.start_date,
				end_date: item.end_date,
				description: item.description,
				job_id: item.job_id,
			});
		}
	}
	useEffect(() => {
		if (checkedItem.length === 0) {
			setHide(true);
		} else {
			setHide(false);
		}
	}, [checkedItem]);
	const navigate = useNavigate();
	const { id } = useParams();
	const notificationArchiveHandler = item => {
		let notificationId = [item.id];
		ReqPost('/notifications/archive', { ids: notificationId })
			.then(res => {
				window.location.reload();
			})
			.catch(err => {
				alert(err.message);
			});
	};

	const notificationDeleteHandler = item => {
		let notificationId = [item.id];
		ReqPost('/notifications/delete', { ids: notificationId })
			.then(res => {
				window.location.reload();
			})
			.catch(err => {
				alert(err.message);
			});
	};

	const selectedArchiveHandler = () => {
		ReqPost('/notifications/archive', { ids: checkedItem })
			.then(res => {
				console.log(res.data);
				console.log('archived123');
				window.location.reload();
			})
			.catch(err => {
				alert(err.message);
			});
	};

	const selectedDeleteHandler = () => {
		ReqPost('/notifications/delete', { ids: checkedItem })
			.then(res => {
				console.log(res.data);
				window.location.reload();
			})
			.catch(err => {
				alert(err.message);
			});
	};

	const unreadChangeHandler = event => {
		console.log(event.target.checked);
		setRequest({ isInitiated: true });
		if (event.target.checked === true) {
			ReqGet('/notification/unread')
				.then(res => {
					console.log(res.data.data);
					setTotalPages(res.data.total / 10);
					setNotificationList(res.data.data);
					setFilterList(res.data.data);
					setRequest({ isInitiated: false, isSuccess: true });
					if (checkedItem && checkedItem.length > 0) {
						const list = res.data.data.map(item => item.id);
						console.log(list);
						setCheckedItems(list);
					} else {
						setCheckedItems([]);
					}
				})
				.catch(err => {
					setRequest({ isSuccess: false, isFailed: true });
					alert(err.message);
				});
			setAllUnread(!allUnread);
		} else {
			searchRequestHandler();
			setAllUnread(!allUnread);
		}
	};

	const selectAllChangeHandler = event => {
		if (event.target.checked === false) {
			setCheckedItems([]);
			setDelectArchieveIcons(true);
			return;
		}
		const list = notificationList.map(item => item.id);
		setCheckedItems(list);
		setDelectArchieveIcons(false);
	};

	const selectChangeHandler = (event, id) => {
		const list = _.cloneDeep(checkedItem);
		if (event.target.checked === false && list.indexOf(id) !== -1) {
			_.remove(list, i => i === id);
		} else {
			list.push(id);
		}
		setCheckedItems(list);
	};

	const [profile, setProfile] = useState({});
	const [open, setOpen] = useState(false);

	useEffect(() => {
		ReqGet('profile')
			.then(res => {
				setProfile(res.data);
			})
			.catch(err => {
				console.log(err.message);
			});
	}, []);

	const submitComponent = async () => {
		navigate('/subscribe');
	};

	const handleClose = () => setOpen(false);
	const notificationClickHandler = item => {
		if (profile.is_subscribed === 1) {
			if (
				item.type.includes('QuestionClientNotify') ||
				item.type.includes('NotifyClientToAnswer') ||
				item.type.includes('NotifyClientToShortlist') ||
				item.type.includes('NotifyClientToExtendTime')
			) {
				if (typeof item.data.job !== 'undefined') {
					console.log(item);
					let notificationId = [item.id];
					ReqPost('/notifications/mark-as-read', { ids: notificationId })
						.then(res => {
							console.log(res.data);

							navigate(0);
						})
						.catch(err => {
							alert(err.message);
						});
					// navigate(`job/${item.data.job.id}`, {
					// 	params: { data: item.data.job },
					// });
				}
			} else if (item.type.includes('QuestionMemberNotify')) {
				if (typeof item.data !== 'undefined') {
					const id = item.data.job.id;
					let notificationId = [item.id];
					ReqPost('/notifications/mark-as-read', { ids: notificationId })
						.then(res => {
							console.log(res.data);
						})
						.catch(err => {
							alert(err.message);
						});
					navigate(`/job/${id}`);
				}
			} else if (item.type.includes('RejectClientNotify')) {
				if (typeof item.data !== 'undefined') {
					const id = item.data.job.id;
					let notificationId = [item.id];
					ReqPost('/notifications/mark-as-read', { ids: notificationId })
						.then(res => {
							console.log(res.data);
						})
						.catch(err => {
							alert(err.message);
						});
					navigate(`/job/${id}/rejectors`);
				}
			} else if (item.type.includes('NewJobPostNotification')) {
				if (typeof item.data !== 'undefined') {
					const id = item.data.job.id;
					let notificationId = [item.id];
					ReqPost('/notifications/mark-as-read', { ids: notificationId })
						.then(res => {
							console.log(res.data);
						})
						.catch(err => {
							alert(err.message);
						});
					navigate(`/job/${id}`);
				}
			} else if (item.type.includes('ApplyClientNotify')) {
				if (typeof item.data !== 'undefined') {
					const id = item?.data?.job?.id;
					const applicantId = item?.data?.applicant?.id;
					let notificationId = [item.id];
					ReqPost('/notifications/mark-as-read', { ids: notificationId })
						.then(res => {
							console.log(res.data);
						})
						.catch(err => {
							alert(err.message);
						});
					navigate(`/apply-client-notify/member/${applicantId}/job/${id}`, {
						params: {
							job: item.data.job,
							member: item.data.applicant,
							title: item.data.title,
						},
					});
				}
			} else {
				return;
			}
		} else {
			setOpen(true);
		}
	};
	const cancelValue = () => {
		setSearch('');
		setEmptyMessage('');
		notificationData();
	};
	const handleMoveHome = () => {
		navigate('/');
	};

	return (
		<Container fluid='true'>
			<Header type='member' />
			<Container className='flex-column mt-5 notification align-content-inherit'>
				<h2 style={{ cursor: 'pointer' }} onClick={handleMoveHome}>
					Notifications
				</h2>
				{result.length ? (
					<div className='mt-3 d-flex justify-content-between align-items-center'>
						<div>
							<Form.Check
								inline
								label='Select All'
								type='checkbox'
								className='mr-5'
								checked={
									result.length === 0
										? false
										: _.size(notificationList) === _.size(checkedItem)
								}
								onChange={selectAllChangeHandler}
							/>
							<Form.Check
								inline
								label='Show all unread'
								type='checkbox'
								defaultChecked={allUnread}
								onChange={unreadChangeHandler}
							/>
						</div>

						<div className='form-group mb-0'>
							<label
								style={{ cursor: 'pointer', display: 'flex' }}
								// className='searchIcon'
							>
								<input
									type='text'
									name='close'
									id='close'
									className='form-control searchInput input'
									placeholder='Search by Job Title'
									value={search}
									onChange={searchChangeHandler}
								/>
								<MdOutlineCancel
									className='close'
									id='closeText'
									onClick={cancelValue}
								/>
								<Button className='ml-2' onClick={searchRequestHandler}>
									Search
								</Button>
							</label>
						</div>
					</div>
				) : (
					''
				)}
				<Stack direction={'row'} gap={2}>
					{!id ||
						(id === '0' && (
							<>
								<Button style={{ width: 'auto' }} variant='secondary'>
									<Link
										to={`/archived-notifications`}
										style={{ color: 'white' }}
									>
										{' '}
										Archived Notifications
									</Link>
								</Button>

								<Button
									className='ml-4'
									onClick={selectedArchiveHandler}
									style={{ width: 'auto', cursor: 'pointer' }}
									variant='success'
									disabled={hide}
								>
									Archived Selected
								</Button>
							</>
						))}
					{result.length ? (
						<Button
							className='ml-4'
							onClick={selectedDeleteHandler}
							style={{ width: 'auto', cursor: 'pointer' }}
							variant='danger'
							disabled={hide}
						>
							Delete Selected
						</Button>
					) : (
						''
					)}
				</Stack>
				<p style={{ textAlign: 'center' }}>{emptymessage}</p>
				{/* {request.isInitiated === true ? <Spinner /> : null} */}
				{request.isInitiated === true ? (
					<div
						style={{
							height: '300px',
							display: 'flex',
							justifyContent: 'center',
							alignItems: 'center',
						}}
					>
						<Spinner animation='grow' variant='primary' />
					</div>
				) : (
					result.map((data, i) => {
						return (
							<div key={i}>
								<Card className='mt-3 mb-2 shadow-sm'>
									<Card.Body>
										<Row>
											<Card.Title
												className='text-primary normal p-1 '
												style={{ marginLeft: '1%' }}
											>
												<span style={{ fontWeight: 'bold' }}>Job ID:</span>
												&nbsp;{data.id} <br />
												{data.travel_type}
												<span style={{ fontWeight: 'bold' }}>Project ID:</span>
												&nbsp;{data?.job_id} <br />
												<span style={{ fontWeight: 'bold' }}>Job Title:</span>
												&nbsp;{data.title}
											</Card.Title>
										</Row>
									</Card.Body>
									<ListGroup className='mt-1'>
										{filterList
											.filter(
												item =>
													item.data.job.id === data.id &&
													(allUnread
														? _.isNull(item.read_at) === allUnread
														: true)
											)
											.map((item, i) => {
												const timeCreated = moment(item.created_at).fromNow();
												return (
													<ListGroup.Item
														key={item.data.job.id}
														className='d-flex justify-content-between align-items-center pl-0 pr-0 border-left-0 border-right-0'
													>
														<Row style={{ marginLeft: '2%' }}>
															<div className='d-flex align-items-center'>
																<Form.Check
																	inline
																	label=''
																	type='checkbox'
																	checked={checkedItem.indexOf(item.id) !== -1}
																	onChange={event =>
																		selectChangeHandler(event, item.id)
																	}
																/>
																<div>
																	<p
																		className={
																			item.read_at === null
																				? 'mb-0 fw-bold'
																				: 'mb-0'
																		}
																		style={styles.title}
																		onClick={() => {
																			notificationClickHandler(item);
																		}}
																	>
																		{item.data.message}
																	</p>
																	{item.read_at === null ? (
																		<div>
																			<span className='dot'></span>
																			<img
																				className='clock-logo'
																				src={clockLogo}
																				alt='clock'
																			/>
																			<span className='fw-bold'>
																				{timeCreated}
																			</span>
																		</div>
																	) : (
																		<div>
																			<img
																				className='clock-logo'
																				src={clockLogo}
																				alt='clock'
																			/>
																			<span>{timeCreated}</span>
																		</div>
																	)}
																</div>
															</div>
														</Row>

														{delectarchieveicons ? (
															<div>
																<img
																	src={archiveLogo}
																	width='35px'
																	alt=''
																	className='pr-3 logo'
																	onClick={() => {
																		notificationArchiveHandler(item);
																	}}
																/>
																<img
																	src={deleteLogo}
																	width='35px'
																	alt=''
																	className='pr-3 logo'
																	onClick={() => {
																		notificationDeleteHandler(item);
																	}}
																/>
															</div>
														) : (
															<div></div>
														)}
													</ListGroup.Item>
												);
											})}
									</ListGroup>
								</Card>
								{open && (
									<Modal
										show={open}
										onHide={handleClose}
										size='md'
										aria-labelledby='contained-modal-title-vcenter'
										centered='true'
									>
										<Modal.Body className='apply-reject-modal'>
											<h6 className='title'>Please Subscribe!</h6>
											<button
												className='btn-modal-yes'
												onClick={submitComponent}
											>
												Subscribe
											</button>{' '}
											<br />
										</Modal.Body>
									</Modal>
								)}
							</div>
						);
					})
				)}
				{request.isInitiated === false && !result.length && (
					<div
						style={{
							height: '300px',
							display: 'flex',
							justifyContent: 'center',
							alignItems: 'center',
						}}
					>
						<h4>No Notification</h4>
					</div>
				)}
				<br /> <br />
				{result.length ? (
					<ReactPaginate
						previousLabel={'previous'}
						nextLabel={'next'}
						breakLabel={'...'}
						breakClassName={'break-me'}
						pageCount={totalPages}
						marginPagesDisplayed={2}
						pageRangeDisplayed={5}
						onPageChange={handlePageClick}
						containerClassName={'pagination'}
						activeClassName={'active'}
						pageLinkClassName='page-link'
						breakLinkClassName='page-link'
						nextLinkClassName='page-link'
						previousLinkClassName='page-link'
						pageClassName='page-item'
						nextClassName='page-item'
						renderOnZeroPageCount={null}
						previousClassName='page-item'
					/>
				) : (
					''
				)}
			</Container>
			<Footer />
		</Container>
	);
}
export default Notifications;
